import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Translations } from '../../models';
import { TRANSLATION_URL_TOKEN } from '../../tokens';
import { ErrorHandlingHeader } from 'shared-utils';

@Injectable({
  providedIn: 'root',
})
export class TranslationHttpService {
  private readonly http = inject(HttpClient);
  private readonly url = inject(TRANSLATION_URL_TOKEN);

  getAllTranslation(): Observable<Translations> {
    return this.http
      .get<Translations>(`${this.url}/translations`, {
        headers: { [ErrorHandlingHeader.Ignore]: true.toString() },
      })
      .pipe(catchError(() => of({})));
  }
}
